
import { useState, useEffect } from "react";


import input_check from "../input_check.png";
import input_error from "../input_error.png";


function InputInteger(props)
{
 
    var v_min = 0;
    var v_max = 9999999;

    if(props.min != null && props.min != undefined) v_min = props.min;    
    if(props.max != null && props.max != undefined) v_max = props.max;

    const [val, setVal] = useState(props.value);    

    const [val_min, setValMin] = useState(v_min);
    const [val_max, setValMax] = useState(v_max);

    const [cn, setClassName] = useState('');

    const [onShow,setOnShow] = useState(false);


    const validate = (vx) => {
        return false;
      };


    

    const checkAndChange = (e) =>
    {
        var v = e.target.value;

        v = v.replace(/[^0-9.]/g, ''); 

         if(v.length == 0) v = 0;

         console.log("err " , v);
       
         v = parseInt(v);    
         
        

         setVal(v);


        var correct = true;


        if( parseInt(v) < parseInt( val_min) )    correct = false;
        if(parseInt(v)  > parseInt(val_max) )     correct = false;       

       // console.log("Val: ", parseInt(v),"min: ", parseInt(val_min), "max: ", parseInt(val_max), val_max, correct  );

 
                 
        
        if(correct == false)
        {
            setClassName('incorrent');
        }else
        {
            setClassName('corrent');           
        }

        if(props.valChange != null && props.valChange != undefined)
        {
            props.valChange(props.name, v, correct,'');
        }else
        {
            console.log('No support for valChange');
        }    
    }

    const onKeyDown = (e) => {
        if (e.key === 'Enter') {
               if(props.goNext != null && props.goNext != undefined)
               {
                  props.goNext();
               }
          } 
    }


    if(cn.length < 2)
    {
        var correct = true;
        


        if( parseInt(val) < parseInt( val_min) ) correct = false;
        if(parseInt(val) > parseInt(val_max) )  correct = false;       
        
        

      
        if(correct == false)
        {
            setClassName('incorrent');
        }else
        {
            setClassName('corrent');           
        }
    }

    var imgx = null;

    if(cn == "incorrent" )
    {
        imgx = <img  className="input_status" src={input_error} />
    }

    
    if(cn == "corrent"  )
    {
        imgx = <img className="input_status" src={input_check} />
    }


    useEffect(() => {

        if(val != props.value) //aktualizuj jesli sie zmieni..
        {
            setVal(props.value);
            setOnShow(false);
        }

        if( onShow == false && props.valChange != null && props.valChange != undefined ) //sprawdz czy dane sa poprawne i wyslij wyzej
        {
             var correct = true;
             if(cn == "incorrent" ) correct = false;                 
             setOnShow(true);
             props.valChange(props.name, val, correct,'');
    
        }
    })

     

 
    var tmp = parseInt(val);
    
 
        
        if(tmp.length == 0) tmp = "0";
    

        var err = "";
        if(props.err != undefined  &&  props.err != null ) 
        {       
            if(props.err[props.name] != null  && props.err[props.name] != undefined    ) err = props.err[props.name]['param'];
        }    
        
        
        var cnX = cn;
        if(val != null && val != undefined &&  val.length < 1 && cnX == 'corrent')
            {
                cnX = '';
            }


    return <fieldset>        
        <input type="phone"  value={tmp} onChange={checkAndChange} onKeyDown={onKeyDown} name={props.name} placeholder={props.placeholder} className={" w150  " + cnX} />        
        {imgx}
        <br/>
        <span className="form_err">{err + " "} &nbsp; </span>
    </fieldset>
}


export default InputInteger;